import React, {Component} from "react";
import {connect} from 'react-redux'
import FJPanelAnimation from "../../../common/component/FJPanelAnimation/FJPanelAnimation";
import FJAdjustView from "../view/FJAdjustView";
import {FJFilterAction} from "../../../redux/action/FJRoot.action";

class FJAdjustContainer extends Component {

  constructor(props) {
    super(props);
    this.list = [
      {
        key: 'exposure',
        min: -100,
        max: 100,
      },
      {
        key: 'contrast',
        min: -100,
        max: 100,
      },
      {
        key: 'brightness',
        min: -100,
        max: 100,
      },
      {
        key: 'temperature',
        min: -100,
        max: 100,
        sliderColor: {from: 'rgba(75,120,195,1)', to: 'rgba(219,165,47,1)'},
      },
      {
        key: 'tint',
        min: -100,
        max: 100,
        sliderColor: {from: 'rgba(46,218,58,1)', to: 'rgba(172,95,190,1)'},
      },
      {
        key: 'saturation',
        min: -100,
        max: 100,
      },
      {
        key: 'highlights',
        min: -100,
        max: 100,
      },
      {
        key: 'shadows',
        min: -100,
        max: 100,
      },
      {
        key: 'vignette',
        min: 0,
        max: 100,
      },
    ];
  }

  _render = () => {
    const {
      adjustActive,
      exposure,
      brightness,
      temperature,
      tint,
      saturation,
      contrast,
      highlights,
      shadows,
      vignette
    } = this.props;
    const {onAdjustChange, onAdjustActiveChange, onReset, disableAdjusts, applyToAll} = this.props;
    const values = {exposure, brightness, temperature, tint, saturation, contrast, highlights, shadows, vignette};
    return (
      <FJAdjustView list={this.list}
                    disableAdjusts={disableAdjusts}
                    values={values}
                    adjustActive={adjustActive}
                    applyToAll={applyToAll}
                    onReset={onReset}
                    onAdjustActiveChange={onAdjustActiveChange}
                    onAdjustChange={onAdjustChange}/>
    );
  };

  render() {
    const {isShow} = this.props;
    return (
      <FJPanelAnimation active={isShow} render={this._render}/>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adjustActive: state.filter.adjustActive,
    exposure: state.filter.exposure,
    brightness: state.filter.brightness,
    temperature: state.filter.temperature,
    tint: state.filter.tint,
    saturation: state.filter.saturation,
    contrast: state.filter.contrast,
    highlights: state.filter.highlights,
    shadows: state.filter.shadows,
    vignette: state.filter.vignette,
    disableAdjusts: state.filter.disableAdjusts,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAdjustActiveChange: function (active) {
      dispatch(FJFilterAction.adjustActiveChangeAction(active));
    },
    onAdjustChange: function (itemKey, data) {
      dispatch(FJFilterAction.adjustDataChangeAction(itemKey, data));
    },
    applyToAll: function () {
      dispatch(FJFilterAction.applyToAllForAdjustAction());
    },
    onReset: function () {
      dispatch(FJFilterAction.resetAdjustAction());
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJAdjustContainer);

